export function formatStoreDisplayName(storeName, storeId) {
  return `${storeName} [id: ${storeId}]`;
}
